// 1. React
import { memo } from "react";

// 2. Helpers
import { useTranslate } from "helpers";

// 3. Types
import { OfferHeaderProps } from "./types";

// 4. Form hooks
import {
    useHandleDateChange,
    useHandleDropdownChange,
    useHandleNumberFieldChange,
} from "services/forms/hooks";

// 6. UI Components
import ContactDropdown from "ui/components/Dropdown/ContactDropdown/ContactDropdown";
import VehicleDropdown from "ui/components/Dropdown/VehicleDropdown/VehicleDropdown";
import { DatePicker } from "ui/components/DatePicker";
import { NumberField } from "ui/components/TextField/NumberField";
import { TextField } from "ui/components/TextField/TextField";
const OfferHeader: React.FC<OfferHeaderProps> = (props) => {
    const { formValues, setFormValues, errors } = props;

    const { t } = useTranslate();

    const handleDropdownChange = useHandleDropdownChange(
        setFormValues,
        formValues
    );

    const handleDateChange = useHandleDateChange(setFormValues, formValues);

    const handleNumberFieldChange = useHandleNumberFieldChange(
        setFormValues,
        formValues
    );

    return (
        <>
            <div className="flex flex-col gap-3 mb-3">
                <div className="flex gap-4">
                    <div className="w-1/3">
                        <TextField
                            label={t("admin.fleet.vehicle.offer.sale.item.add.offernumber")}
                            type="text"
                            name="offerNumber"
                            value={formValues.offerNumber}
                            error={errors.name}
                            required
                            disabled
                        />
                    </div>
                    <div className="w-2/3">
                        <VehicleDropdown
                            name="vehicleId"
                            label={t("admin.fleet.vehicle.offer.sale.add.vehicle")}
                            placeholder={t(
                                "admin.fleet.vehicle.offer.sale.add.vehicle.placeholder"
                            )}
                            value={formValues.vehicleId}
                            onChange={handleDropdownChange}
                            error={errors.vehicleId}
                            required
                            disabled={!!formValues.vehicleId}
                        />
                    </div>

                </div>
                <div className="flex gap-4">
                    <div className="flex-1">
                        <DatePicker
                            name="offerDate"
                            label={t("admin.fleet.vehicle.offer.sale.add.offerdate")}
                            placeholder={t(
                                "admin.fleet.vehicle.offer.sale.add.offerdate.placeholder"
                            )}
                            onChange={handleDateChange}
                            error={errors.offerDate}
                            value={formValues.offerDate}
                            width="full"
                            required
                        />
                    </div>
                    <div className="flex-1">
                        <DatePicker
                            name="dueDate"
                            label={t("admin.fleet.vehicle.offer.sale.add.duedate")}
                            placeholder={t(
                                "admin.fleet.vehicle.offer.sale.add.duedate.placeholder"
                            )}
                            onChange={handleDateChange}
                            error={errors.dueDate}
                            value={formValues.dueDate}
                            width="full"
                            required
                        />
                    </div>
                    <div className="flex flex-1 items-end ">
                        <label className="block text-sm mb-2 mr-3 font-medium leading-6 text-[#344054]">
                            {t("admin.fleet.vehicle.offer.sale.add.durationdays")}
                        </label>
                        <div className="flex-1">
                            <NumberField
                                name="durationDays"
                                onChange={handleNumberFieldChange}
                                value={formValues.durationDays}
                                decimals={0}
                            ></NumberField>
                        </div>
                    </div>
                </div>
                <div className="flex gap-4">
                    <div className="flex-1">
                        <ContactDropdown
                            placeholder={t(
                                "admin.fleet.vehicle.offer.sale.add.contact.client.placeholder"
                            )}
                            label={t("admin.fleet.vehicle.offer.sale.add.contact.client")}
                            name="contactClientId"
                            value={formValues.contactClientId}
                            onChange={handleDropdownChange}
                            error={errors.contactClientId}
                            required
                        />
                    </div>
                    <div className="flex-1">
                        <ContactDropdown
                            placeholder={t(
                                "admin.fleet.vehicle.offer.sale.add.contact.consumer.placeholder"
                            )}
                            label={t("admin.fleet.vehicle.offer.sale.add.contact.consumer")}
                            name="contactConsumerId"
                            value={formValues.contactConsumerId}
                            onChange={handleDropdownChange}
                            error={errors.contactConsumerId}
                        />
                    </div>
                    <div className="flex-1"></div>
                </div>
            </div>
        </>
    );
};

export default memo(OfferHeader);
